<!-- 会员资料 -->

<template>
    <div class="vipMan">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <!-- <div class="left search flex flex-align-center">
                            <input type="text" class="left" placeholder="请输入姓名或相关信息">
                            <i class="el-icon-search"></i>
                        </div> -->
                       <!--  <div class="right addBtn">
                            <button type="button" @click="dialogVisible=true"><i class="el-icon-plus"></i>添加员工</button>
                        </div> -->
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:20%">会员号码</th>
                                <th style="width:10%">会员名称</th>
                                <th style="width:10%">电话</th>
                                <th style="width:15%">余额</th>
                                <th style="width:15%">入会时间</th>
                                <th style="width:15%">推荐人</th>
                                <th style="width:15%">电子券数量</th>
                                <!-- <th style="width:10%">操作</th> -->
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:vipData.length>pageSize}">
                                    <tr v-for="item in vipData">
                                        <td style="width:20%" v-text="item.code"></td>
                                        <td style="width:10%" v-text="item.memberName"></td>
                                        <td style="width:10%" v-text="item.mobile"></td>
                                        <td style="width:15%" v-text="item.amountBonus"></td>
                                        <td style="width:15%">
                                            <span v-if="item.addTime">{{item.addTime | numberToDate('')}}</span>
                                            <span v-if="!item.addTime"></span>
                                        </td>
                                        <td style="width:15%" v-text="item.referralUserName"></td>
                                        <td style="width:15%" v-text=""><span v-if="item.code">-</span></td>
                                        <!-- <td style="width:11%">
                                            <div v-if="item.id" class="btnInline">
                                                <el-button type="text"  title="删除" @click="delteVipMan(item)"><i class="iconfont icon-icon1460188478041"></i></el-button>
                                            </div>
                                        </td> -->
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 分页器 -->
                <!-- <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left">1</span>
                                <span class="next flex flex-align-center flex-pack-center left havePage"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right">第 1 / 9 条</div>
                        <div class="totalPage flex flex-align-center right">共100条</div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props:['curStoreId', 'pageSize'],
    	data () {
    		return {
                dialogVisible: false,
                vipData:[]
    		}
    	},
        methods: {
            getVipData(){
                this.$http.get('/members?storeId='+this.curStoreId).then((res)=>{
                    this.vipData = res.data;
                    for(let i = 0, len = this.vipData.length; i < len; i++){
                        this.vipData[i].amountBonus =  (this.vipData[i].bonus+this.vipData[i].amount).toFixed(2)
                    }
                    if( this.vipData.length < this.pageSize ){
                        for(let i = 0, len = this.pageSize - this.vipData.length; i < len; i++){
                            this.vipData.push({})
                        }
                    }
                })
            },
            // 删除会员
            delteVipMan(item){
                this.$confirm('此操作将删除该会员, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    this.$http.delete('/members/' + item.id).then((res)=>{
                        this.getVipData();
                    })
                }).catch(() => {

                });

            },
            addVipMan(){
                let vipMan = {
                    "id": this.$uuid.create(1).hex,
                    "name": '酱HMP',
                    "storeId": this.curStoreId,
                    "code": this.$uuid.create(1).hex,
                    "referralMemberId": '',//推荐人id
                    "referralMemberName": 'yuzijiang',//推荐人name
                    "points": 3,//积分
                    "amount": 30,//金额
                };
                this.$http.put('/members',vipMan).then((res)=>{
                    console.log(res)
                })
            }
        },
        created: function () {
            for (var i = 0; i < this.pageSize; i++) {
                this.vipData.push({});
            }
        },
        mounted: function () {
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-qihuan');
                $('.el-message-box__header .el-message-box__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            })
            this.getVipData();
            // this.addVipMan();
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "vipMan";
</style>



// WEBPACK FOOTER //
// vipMan.vue?1a2cae72